export const prepaymentTypes = [
  { id: 'services', name: 'Services' },
  { id: 'expenses', name: 'Expenses' },
  { id: 'products', name: 'Products' },
  { id: 'other_items', name: 'Other Items' },
];

// A prepayment locks the moment it lands on an invoice — draft included, because the draft already
// carries the prepaid amount — and stays locked once it has offset fees on another invoice.
export function isPrepaymentLocked(prepayment) {
  return !!prepayment.invoice || Number(prepayment.amountUsed ?? 0) > 0;
}
